import { TEmblaSliderElement } from "./types";
import useEmblaSlider from "./useEmblaSlider";

const EmblaSliderViewport: React.FC<TEmblaSliderElement> = ({
  children,
  className = "Embla-Slider-viewport",
}) => {
  const [emblaRef] = useEmblaSlider()!;
  return (
    <div ref={emblaRef} className={className}>
      {children}
    </div>
  );
};

export default EmblaSliderViewport;
